import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="border-t border-white/10 bg-base-900/60">
      <div class="mx-auto max-w-7xl px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div class="col-span-2">
          <div class="flex items-center gap-2 text-xl font-bold text-white mb-3">
            <img src="assets/logo.png" alt="Neonnexux logo" class="h-7 w-7 object-contain" />
            Neonnexux
          </div>
          <p class="text-white/50 text-sm max-w-xs">
            AI-powered interview assessment platform for smarter, fairer, faster hiring.
          </p>
          <p class="text-white/40 text-sm mt-4">Bhubaneswar, Odisha, India</p>
          <a href="mailto:support@neonnexux.com" class="text-brand-400 text-sm hover:underline">support&#64;neonnexux.com</a>
        </div>

        <div>
          <h4 class="text-white font-semibold mb-3 text-sm">Company</h4>
          <ul class="space-y-2 text-sm text-white/50">
            <li><a routerLink="/about" class="hover:text-white">About</a></li>
            <li><a routerLink="/pricing" class="hover:text-white">Pricing</a></li>
            <li><a routerLink="/blogs" class="hover:text-white">Blogs</a></li>
            <li><a routerLink="/contact" class="hover:text-white">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 class="text-white font-semibold mb-3 text-sm">Legal</h4>
          <ul class="space-y-2 text-sm text-white/50">
            <li><a routerLink="/privacy-policy" class="hover:text-white">Privacy Policy</a></li>
            <li><a routerLink="/terms" class="hover:text-white">Terms &amp; Conditions</a></li>
            <li><a href="mailto:support@neonnexux.com" class="hover:text-white">Support</a></li>
          </ul>
        </div>

<div>
          <h4 class="text-white font-semibold mb-3 text-sm">Connect</h4>
          <div class="flex items-center gap-2 mb-3">
            <img src="assets/logo.png" alt="Neonnexux logo" class="h-7 w-7 object-contain" />
            <span class="text-white/70 text-sm">Follow us</span>
          </div>
          <ul class="space-y-2 text-sm text-white/50">
            <li><a href="https://www.linkedin.com/company/neonnexux" target="_blank" rel="noopener" class="hover:text-white">LinkedIn</a></li>
            <li><a href="https://x.com/neonnexux1" target="_blank" rel="noopener" class="hover:text-white">Twitter / X</a></li>
            <li><a href="https://instagram.com/neonnexux" target="_blank" rel="noopener" class="hover:text-white">Instagram</a></li>
          </ul>
        </div>
      </div>

      <div class="border-t border-white/5 py-6 text-center text-xs text-white/40">
        © 2026 Neonnexux. All Rights Reserved.
      </div>
    </footer>
  `,
})
export class FooterComponent {}
